<template>
  <div>
    <v-row>
      <v-col cols="12">
        <FilterReport @search="handleSearch" />
      </v-col>
    </v-row>
    <v-row class="report-content">
      <v-col cols="12">
        <Statistic :query="query" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FilterReport from './FilterReport.vue'
import Statistic from './Statistic.vue'
export default {
  components: {
    FilterReport,
    Statistic,
  },
  data() {
    return {
      query: null,
    }
  },
  methods: {
    handleSearch(params) {
      this.query = {
        classId: params.class,
        lessonIds: params.lessons,
      }
    },
    handleUpdateStudents(students) {
      this.selectedStudents = students
    },
  },
}
</script>

<style scoped>
.report-content {
  margin-top: 20px;
}

.student-list {
  padding-right: 10px;
}

.session-info {
  padding-left: 10px;
}
</style>
